import { Search } from "lucide-react";

const STATUSES = ["new", "contacted", "qualified", "closed", "rejected"];

export default function DashboardFilters({ q, setQ, status, setStatus, temperature, setTemperature, state, setState }) {
  return (
    <div className="flex flex-wrap items-center gap-3 border-b border-[#E0E4E2] p-4">
      <div className="relative flex-1 min-w-[220px]">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[#5C6B68]" />
        <input
          placeholder="Search by name, email, phone, city…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          className="input-field pl-9"
          data-testid="leads-search"
        />
      </div>
      <select value={status} onChange={(e) => setStatus(e.target.value)} className="input-field w-auto" data-testid="leads-filter-status">
        <option value="all">All statuses</option>
        {STATUSES.map((s) => <option key={s} value={s}>{s[0].toUpperCase() + s.slice(1)}</option>)}
      </select>
      <select value={temperature} onChange={(e) => setTemperature(e.target.value)} className="input-field w-auto" data-testid="leads-filter-temp">
        <option value="all">All temperatures</option>
        <option value="hot">🔥 Hot only</option>
        <option value="warm">Warm only</option>
        <option value="cold">Cold only</option>
      </select>
      <select value={state} onChange={(e) => setState(e.target.value)} className="input-field w-auto" data-testid="leads-filter-state">
        <option value="all">NY + NJ</option>
        <option value="NY">NY only</option>
        <option value="NJ">NJ only</option>
      </select>
    </div>
  );
}
